import React, { useState, useEffect } from "react";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import styles from "./Login.module.css";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/icons/qvh-logo.svg";

const Login = () => {
  const { loginUser, isLoginLoading, user, loginError, setLoginError } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState("");

  // Redirect if already logged in
  useEffect(() => {
    if (user) {
      navigate("/start", { replace: true });
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLocalError("");
    setLoginError(null);        // Clear previous context error

    const { email, password } = formData;

    if (!email || !password) {
      setLocalError("Bitte E-Mail und Passwort eingeben.");
      return;
    }

    const result = await loginUser(email, password);

    // Only clear form on successful login
    if (result?.success) {
      setFormData({ email: "", password: "" });
    }
  };

  // Combined error message
  const errorMessage = localError || loginError;

  return (
    <div className={styles["login-page"]}>
      <div className={styles.container}>
        <img
          src={logo}
          alt="IETEC Logo"
          className={styles["header-logo"]}
        />
        <h1>Login</h1>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles["form-group"]}>
            <label className={styles.label}>E-Mail</label>
            <input
              type="email"
              name="email"
              className={styles.input}
              value={formData.email}
              onChange={handleChange}
              autoComplete="email"
              disabled={isLoginLoading}
            />
          </div>

          <div className={styles["form-group"]}>
            <label className={styles.label}>Passwort</label>
            <div className={styles["password-wrapper"]}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className={styles.input}
                value={formData.password}
                onChange={handleChange}
                autoComplete="current-password"
                disabled={isLoginLoading}
              />
              <span
                className={styles["toggle-password"]}
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <EyeSlashFill /> : <EyeFill />}
              </span>
            </div>
          </div>

          <div className={styles["error-space"]}>
            {errorMessage && (
              <p className={styles["error-text"]}>{errorMessage}</p>
            )}
          </div>

          <div className={styles.actions}>
            <button
              type="submit"
              className={styles["btn-primary"]}
              disabled={isLoginLoading}
            >
              {isLoginLoading ? "Anmelden..." : "Anmelden"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;